// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDebit} from '../../shared/repositories';
import {readDebitTypes} from '../../shared/action-creators/debit-types';
import {updateConfirmationModalVisibility} from './confirmation-modal';
import {updateFullDebitModalVisibility} from './full-debit-modal';

export const readDebit = claimNumber =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const debit = await getDebit(claimNumber);

            dispatch({
                debit,
                type: actions.UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM
            });

            debit.isDebitFormRequired ?
                updateConfirmationModalVisibility(true) :
                updateFullDebitModalVisibility(true)(dispatch);

            readDebitTypes(actions.UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_TYPE, 'F')(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/get-debit.js